import React, { Component } from 'react';
//import withStyles from "@material-ui/core/styles/withStyles";
import { Grid } from '@material-ui/core';
import Version from "version";
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import nbLocale from "date-fns/locale/nb";
import svLocale from "date-fns/locale/sv";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import theme from 'theme';
import { StyledTextField } from '../controls/TextField';

import { LargeButton } from '../controls/components/Buttons';

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);


class ChangeUserAddress extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeUserAddress", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            vmArg: {
                SubscriptionNo: props.SubscriptionNo,
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Firstname: '',
            Lastname: '',
            Birthdate: '',
            AddressLine: '',
            PostalCode: '',
            City: '',
            EmailAddress: '',
            ContactPhone: '',
            AllowEmailPassword: false,
            ExportUserInfo: false,
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
            BlockChangeAddress: false,
            IsUserAddressPrimary: false,
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            setTimeout(
                function () {

                    MySwal.fire({
                        title: this.props.t('selfcare:notification.changeregistered'),
                        html: this.props.t('selfcare:notification.infoupdatedwithinminutes'),
                        icon: 'success',
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        if (this.props.handleRefresh)
                            this.props.handleRefresh();
                        if (this.props.handleClose)
                            this.props.handleClose();
                    });
                }.bind(this),
                100
            );

        }
        if (nextState.OrderError && !this.state.OrderError) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: this.props.t('selfcare:notification.changefailed'),
                        html: nextState.OrderError,
                        icon: 'error',
                        confirmButtonColor: theme.palette.primary.main,
                    });
                    this.setState({ buzy: false });
                }.bind(this),
                100
            );
        }
        if (nextState.Message && !this.state.Message) {
            setTimeout(
                function () {
                    MySwal.fire({
                        title: nextState.Message.MessageTitle,
                        html: nextState.Message.MessageText,
                        icon: nextState.Message.MessageType,
                        confirmButtonText: nextState.Message.ConfirmButtonText,
                        confirmButtonColor: theme.palette.primary.main,
                    }).then((result) => {
                        switch (nextState.Message.Action) {
                            case 'close':
                                if (this.props.handleRefresh)
                                    this.props.handleRefresh();
                                if (this.props.handleClose)
                                    this.props.handleClose();
                                break;
                            case 'none':
                                break;
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'redirect':
                                window.location.replace(nextState.Message.ActionParam);
                                break;
                            default:
                                break;
                        }
                    });
                }.bind(this),
                10
            );
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            setTimeout(
                function () {
                    this.setState({ buzy: false });
                    this.setFocus(nextState.ErrorField);
                }.bind(this),
                100
            );
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    setFocus = fieldName => {
        switch (fieldName) {
            case "Firstname":
                if (this.Firstname) {
                    setTimeout(() => {
                        this.Firstname.focus();
                    }, 10);
                }
                break;
            case "Lastname":
                if (this.Lastname) {
                    setTimeout(() => {
                        this.Lastname.focus();
                    }, 10);
                }
                break;
            case "Birthdate":
                if (this.Birthdate) {
                    setTimeout(() => {
                        this.Birthdate.focus();
                    }, 10);
                }
                break;
            case "EmailAddress":
                if (this.EmailAddress) {
                    setTimeout(() => {
                        this.EmailAddress.focus();
                    }, 10);
                }
                break;
            case "AddressLine":
                if (this.AddressLine) {
                    setTimeout(() => {
                        this.AddressLine.focus();
                    }, 10);
                }
                break;
            case "PostalCode":
                if (this.PostalCode) {
                    setTimeout(() => {
                        this.PostalCode.focus();
                    }, 10);
                }
                break;
        }
    }

    handleDateChange = date => {
        this.setState({ Birthdate: date });
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
        if (name === 'PostalCode') {
            this.dispatchState({ Lookup: event.target.value });
        }
    }

    handleSave = () => {
        this.dispatchState({ PerformChange: { Firstname: this.state.Firstname, Lastname: this.state.Lastname, Birthdate: this.state.Birthdate, AddressLine: this.state.AddressLine, PostalCode: this.state.PostalCode, EmailAddress: this.state.EmailAddress, IsUserAddressPrimary: this.state.IsUserAddressPrimary, AllowEmailPassword: this.state.AllowEmailPassword } });
        this.setState({ buzy: true, ErrorField: '' });
    }
    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        const classes = this.props;
        const { t } = this.props;
        const postcodelen = this.state.IsNorway ? 4 : 5;
        const dateformat = this.state.IsNorway ? 'dd.MM.yyyy' : 'yyyy-MM-dd';
        const dateplace = this.state.IsNorway ? 'dd.mm.åååå' : 'åååå-mm-dd';
        return (
            <div style={{ height: '100%' }}>
                {this.state.IsAdministrating && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.now-administrating-number', { 0: this.state.AdministratedMsisdn }) }} /></div>}
                <div style={{ backgroundColor: theme.palette.primary.main, color: '#FFF', padding: '20px' }}>
                    <Grid container justify="center">
                        <Grid item xs={12} sm={10}>
                            <Icon name="profile" size={48} color="#FFFFFF" />
                            <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                {t('selfcare:item.updateuserinfo')}
                            </ div>
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <Grid container justify="center">
                        <Grid item xs={12} sm={10}>
                            <div style={{ padding: '20px 10px', fontSize: '16px', fontWeight: '700' }}>{t('selfcare:title.userinfo')}</div>
                            <Grid container >
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth error={this.state.ErrorField === 'Firstname'}
                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                        label={t('selfcare:label.firstname')}
                                        value={this.state.Firstname}
                                        id="Firstname"
                                        onChange={this.handleChange('Firstname')}
                                        inputProps={{ maxLength: 30 }}
                                        helperText={this.state.ErrorField === 'Firstname' && this.state.ErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={(el) => { this.Firstname = el; }}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth error={this.state.ErrorField === 'Lastname'}
                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                        label={t('selfcare:label.lastname')}
                                        value={this.state.Lastname}
                                        id="Lastname"
                                        onChange={this.handleChange('Lastname')}
                                        className={classes.textField}
                                        inputProps={{ maxLength: 30 }}
                                        helperText={this.state.ErrorField === 'Lastname' && this.state.ErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={(el) => { this.Lastname = el; }}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={this.state.IsNorway ? nbLocale : svLocale}>
                                        <DatePicker TextFieldComponent={StyledTextField} error={this.state.ErrorField === 'Birthdate'}
                                            disabled={this.state.buzy || this.state.BlockChangeAddress}
                                            fullWidth
                                            clearable
                                            clearLabel={t('selfcare:label.clear')}
                                            label={t('selfcare:label.birthdate')}
                                            minDate={new Date("1910-01-01")}
                                            disableFuture
                                            value={this.state.Birthdate}
                                            onChange={this.handleDateChange}
                                            format={dateformat}
                                            emptyLabel=""
                                            invalidLabel=""
                                            placeholder={dateplace}
                                            invalidDateMessage={t('selfcare:label.invaliddate')}
                                            minDateMessage={t('selfcare:label.mindate')}
                                            autoOk
                                            cancelLabel={t('selfcare:label.cancel')}
                                            inputRef={(el) => { this.Birthdate = el; }}
                                            helperText={this.state.ErrorField === 'Birthdate' && this.state.ErrorMessage}
                                            inputVariant="outlined"
                                            margin="dense"
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth error={this.state.ErrorField === 'AddressLine'}
                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                        label={t('selfcare:label.address')}
                                        value={this.state.AddressLine}
                                        onChange={this.handleChange('AddressLine')}
                                        id="AddressLine"
                                        className={classes.textField}
                                        inputProps={{ maxLength: 30 }}
                                        helperText={this.state.ErrorField === 'AddressLine' && this.state.ErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={(el) => { this.AddressLine = el; }}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth error={this.state.ErrorField === 'PostalCode'}
                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                        label={t('selfcare:label.postalcode')}
                                        value={this.state.PostalCode}
                                        onChange={this.handleChange('PostalCode')}
                                        id="PostalCode"
                                        className={classes.textField}
                                        type='tel'
                                        inputProps={{ maxLength: { postcodelen } }}
                                        helperText={this.state.ErrorField === 'PostalCode' && this.state.ErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={(el) => { this.PostalCode = el; }}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth
                                        disabled
                                        label={t('selfcare:label.postalcity')}
                                        value={this.state.City}
                                        id="City"
                                        InputLabelProps={{ shrink: true }}
                                        className={classes.textField}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} style={{ padding: '10px' }}>
                                    <StyledTextField fullWidth error={this.state.ErrorField === 'EmailAddress'}
                                        disabled={this.state.buzy || this.state.BlockChangeAddress}
                                        label={t('selfcare:label.email')}
                                        value={this.state.EmailAddress}
                                        onChange={this.handleChange('EmailAddress')}
                                        id="EmailAddress"
                                        className={classes.textField}
                                        inputProps={{ maxLength: 50 }}
                                        type='email'
                                        helperText={this.state.ErrorField === 'EmailAddress' && this.state.ErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                        inputRef={(el) => { this.EmailAddress = el; }}
                                        variant="outlined"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={12} style={{ padding: '10px' }}>
                                    {this.state.IsNorway &&
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.IsUserAddressPrimary}
                                                    onChange={(e) => { this.setState({ IsUserAddressPrimary: e.target.checked }); }}
                                                    disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                    color="primary"
                                                />
                                            }
                                            label={t('selfcare:label.transferuserinfodirectoryservices')}
                                            labelPlacement="end"
                                        />}
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.AllowEmailPassword}
                                                onChange={(e) => { this.setState({ AllowEmailPassword: e.target.checked }); }}
                                                disabled={this.state.buzy || this.state.BlockChangeAddress}
                                                color="primary"
                                            />
                                        }
                                        label={t('selfcare:label.emailcanreceivepassword')}
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container justify="space-around" direction="column" alignItems="center">
                                <div style={{ paddingTop: '20px' }}>
                                    <LargeButton onClick={() => { this.handleSave(); }} disabled={this.state.buzy || this.state.BlockChangeAddress} style={{ marginRight: '10px' }}>{t('selfcare:button.update')}</LargeButton>
                                    <LargeButton color="secondary" variant="text" id='cancel' disabled={this.state.buzy} onClick={() => { this.props.handleClose(); }}>{t('selfcare:button.cancel')}</LargeButton>
                                </div>
                                {this.state.buzy &&
                                    <Grid item>
                                        <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}
ChangeUserAddress.propTypes = {
};

export default compose(
    withTranslation(),
)(withAITracking(reactPlugin, ChangeUserAddress));

